import React from 'react';
import { useStoreActions, useStoreState } from '@discover-data/stores/restaurant/hooks';
import Switch from '@discover-components/ui/switch';
import Label from '@discover-ui/label';

export default function EnabledSwitch() {
  const enabled = useStoreState((state) => state.enabled);
  const enable = useStoreActions((state) => state.enable);
  const disable = useStoreActions((state) => state.disable);

  return (
    <>
      <Label className="m-0">Enabled</Label>
      <Switch
        checked={enabled}
        onCheckedChange={() => {
          if (enabled) {
            disable();
          } else {
            enable();
          }
        }}
      />
    </>
  );
}
